// extracted by mini-css-extract-plugin
export default {"root":"Markdown-root-3d2b06281c90101cf5bd89f8e574c33c"};